import { Link } from 'react-router-dom';
import { articles } from '@/mocks/data';

const articleCovers: Record<string, string> = {
  'article-cover-01': 'https://readdy.ai/api/search-image?query=Modern%20smartphone%20displaying%20colorful%20comic%20reading%20app%2C%20cozy%20reading%20nook%20with%20warm%20lighting%2C%20minimalist%20composition%2C%20soft%20shadows%2C%20natural%20warm%20tones%2C%20clean%20modern%20aesthetic&width=800&height=500&seq=article-cover-01&orientation=landscape',
  'article-cover-02': 'https://readdy.ai/api/search-image?query=Smartphone%20with%20download%20icon%20and%20colorful%20comic%20art%2C%20warm%20ambient%20lighting%2C%20cozy%20home%20environment%2C%20minimalist%20modern%20design%2C%20clean%20composition%2C%20soft%20warm%20colors&width=800&height=500&seq=article-cover-02&orientation=landscape',
  'article-cover-03': 'https://readdy.ai/api/search-image?query=Global%20map%20with%20colorful%20comic%20style%20cultural%20elements%2C%20warm%20ambient%20lighting%2C%20vibrant%20illustration%2C%20modern%20digital%20art%2C%20clean%20composition%2C%20professional%20aesthetic&width=800&height=500&seq=article-cover-03&orientation=landscape',
  'article-cover-04': 'https://readdy.ai/api/search-image?query=Colorful%20top%2010%20ranking%20list%20with%20comic%20book%20covers%2C%20warm%20ambient%20lighting%2C%20clean%20modern%20design%2C%20minimalist%20composition%2C%20soft%20shadows%2C%20professional%20aesthetic&width=800&height=500&seq=article-cover-04&orientation=landscape',
  'article-cover-05': 'https://readdy.ai/api/search-image?query=Android%20phone%20with%20APK%20installation%20screen%20and%20comic%20art%2C%20warm%20ambient%20lighting%2C%20clean%20minimalist%20design%2C%20modern%20tech%20aesthetic%2C%20soft%20shadows&width=800&height=500&seq=article-cover-05&orientation=landscape',
  'article-cover-06': 'https://readdy.ai/api/search-image?query=Korean%20drama%20and%20comic%20crossover%20concept%20art%2C%20warm%20cinematic%20lighting%2C%20elegant%20composition%2C%20modern%20digital%20art%2C%20professional%20aesthetic%2C%20clean%20background&width=800&height=500&seq=article-cover-06&orientation=landscape',
};

export default function ArticleSection() {
  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
            韩漫资讯与指南
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
            了解最新韩漫动态，掌握韩漫下载安装技巧
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {articles.slice(0, 6).map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.id}`}
              className="group bg-background-100 rounded-xl overflow-hidden hover:shadow-md transition-all duration-300 cursor-pointer border border-background-200/70"
            >
              <div className="aspect-[16/10] overflow-hidden">
                <img
                  src={articleCovers[article.coverSeq]}
                  alt={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
              </div>
              <div className="p-5">
                <div className="flex items-center gap-3 mb-3">
                  <span className="inline-block px-2.5 py-1 bg-primary-100 text-primary-700 text-xs font-medium rounded-full whitespace-nowrap">
                    {article.categoryName}
                  </span>
                  <span className="text-xs text-foreground-400">
                    {article.date}
                  </span>
                </div>
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 mb-2 line-clamp-2 leading-snug">
                  {article.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-500 mb-3 line-clamp-2 leading-relaxed">
                  {article.summary}
                </p>
                <div className="flex items-center justify-between text-xs text-foreground-400">
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line w-3 h-3 flex items-center justify-center"></i>
                    {article.readCount.toLocaleString()}
                  </span>
                  <span>{article.author}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}